import confetti from "canvas-confetti";

const POG_COLORS = ["#d946ef", "#38bdf8", "#34d399", "#fbbf24", "#a78bfa"];

// Celebratory "POG'd it!" burst — used on POG post & business claim.
export function pogConfetti() {
  const fire = (ratio, opts) =>
    confetti({ origin: { y: 0.62 }, colors: POG_COLORS, particleCount: Math.floor(160 * ratio), ...opts });
  fire(0.25, { spread: 26, startVelocity: 55 });
  fire(0.2, { spread: 60 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.9 });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
  fire(0.1, { spread: 120, startVelocity: 45 });
}
